import React from "react";
import { X } from "lucide-react";

interface ContactResponseModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

const ContactResponseModal: React.FC<ContactResponseModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 relative">
        <button
          title={title}
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <X className="h-6 w-6" />
        </button>
        <h2 className="text-2xl font-bold mb-4">{title}</h2>
        <p className="text-gray-600 mb-6">{message}</p>
        <button
          onClick={onClose}
          className="w-full bg-primary text-white py-3 rounded-full font-bold hover:bg-primary-dark transition"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default ContactResponseModal;
